import { SeoTitleDescription } from "@/types/sites";

const SeoTitleDesc = (
    currentTitle: string,
    seoTitleDescription?: SeoTitleDescription
): null | React.ReactElement[] => {
    const seoTitle = seoTitleDescription?.title || null;
    const seoDescription = seoTitleDescription?.description || null;

    const titleField = seoTitle ? (
        <title key="title">{seoTitle}</title>
    ) : (
        <title key="title">{currentTitle}</title>
    );

    const descriptionField = seoDescription ? (
        <meta key="description" name="description" content={seoDescription} />
    ) : (
        <meta 
            key="description" 
            name="description" 
            content="Find the best online casino bonuses and offers. Compare trusted casino sites with exclusive welcome packages, free spins and no deposit bonuses." 
        />
    );

    return [titleField, descriptionField];
};

export default SeoTitleDesc;
